export default __webpack_public_path__ + "static/media/remove.12cc4f1a.png";